// Thin wrapper around the gtag.js loaded in public/index.html. Guards every
// call so a blocked/missing script (ad blockers, privacy browsers) never
// breaks the actual feature it's attached to.

export function trackEvent(name, params = {}) {
  try {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, params);
  } catch (_) { /* analytics should never break the app */ }
}
